import React from "react";
import { Link } from "react-router-dom";
import "./../styles/Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <span className="footer-name">LearnHut OVGU</span>
          <span className="footer-copy">
            © {year} LearnHut OVGU. All rights reserved.
          </span>
        </div>

        <nav className="footer-links" aria-label="Footer Navigation">
          <Link to="/contact">Kontakt</Link>
          <Link to="/terms">Bedingungen</Link>
          <Link to="/privacy">Datenschutz</Link>
          <Link to="/aboutus">Über Uns</Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
